import { ApiProperty } from '@nestjs/swagger';
export class HarvestIdRequest {
    @ApiProperty()
    harvestId: number;
    @ApiProperty()
    plantId: number;
}